module.exports = __webpack_public_path__ + "static/media/locationList.87d03afc.png";